import getChildrenSelectedCategories from './getChildrenSelectedCategories'
import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'
import { servicePricingTypeEnum } from 'Rentlio/utils/servicePricingTypeEnum'

// when we have excluded services/meals on rate we need to add this excluded services to accommodation price separately for adults/children so we can update live price on layout
const getExcludedServicesTotal = (ratePlan, adults, childrenAges) => {
  if (!ratePlan?.services?.length || !ratePlan?.services?.find(item => !item.isIncluded && !item.isMandatory)) {
    return 0
  }

  const excludedServices = ratePlan.services.filter(item => !item.isIncluded && !item.isMandatory)
  let totalPrice = 0

  excludedServices.map(service => {
    if (!service.dailyPrices?.length) {
      return
    }

    service.dailyPrices.map(dailyPrice => {
      const priceForDay = dailyPrice.price || 0
      if (service.pricingType !== servicePricingTypeEnum.PER_PERSON) {
        totalPrice += priceForDay
        return
      }

      totalPrice += priceForDay * adults

      if (childrenAges && Array.isArray(childrenAges) && childrenAges.length) {
        const selectedCategories = getChildrenSelectedCategories(childrenAges, service?.childrenCategories) || []
        selectedCategories &&
          selectedCategories.map(category => {
            if (category.type === ChildrenCategoriesTypeEnum.FREE_OF_CHARGE) {
              return
            }
            if (category.type === ChildrenCategoriesTypeEnum.AS_ADULT) {
              totalPrice += priceForDay
            }
            if (category.type === ChildrenCategoriesTypeEnum.CUSTOM) {
              // using priceBeforeTax because if vat rate (tax) is excluded from price, backend returns that vat rate in category.percentageValue (percentageValue wil be multiplied with vat rate)
              // for example if percentage is 50% and vat rate is 13% then backend will return 0.5*1.13=0.565 instead of 0.5. price will also include vat rate, so to avoid double taxing we are using priceBeforeTax.
              totalPrice += dailyPrice.priceBeforeTax * ((category.percentageValue || 0) / 100)
            }
            if (category.type === ChildrenCategoriesTypeEnum.MANUAL) {
              totalPrice += category.nominalValue || 0
            }
          })
      }
    })
  })

  return totalPrice
}

export default getExcludedServicesTotal
